export const LEGAL_CONFIG = {
  platformName: "Pattern Market",
  platformUrl: "[ADRES PLATFORMY]",
  companyName: "[NAZWA FIRMY]",
  companyAddress: "[ADRES]",
  companyNip: "[NIP]",
  companyRegon: "[REGON]",
  supportEmail: "support@patternmarket.com",
  complaintsEmail: "[e-mail]",
  privacyPolicyLastUpdated: "[DATA OSTATNIEJ AKTUALIZACJI]",
  newsletterTermsEffectiveDate: "[DATA]",
  showFooterSocialIcons: false,
};
